import React, { useEffect, useRef, useState } from 'react';
import {ZifData} from '../config'
import '../App.css';
import $ from 'jquery';

const GridViewer = ({  }) => {
    const column = 10;
    const gridContainerRef = useRef(null); // 创建一个ref来引用grid-container
    const gridContainerRef1 = useRef(null);
    const [gridWidth, setGridWidth] = useState(0); // 用于存储grid-container的宽度
    const [gridHeight, setGridHeight] = useState(0);
    const [canvasWidth, setCanvasWidth] = useState(0);
    const [canvasHeight, setCanvasHeight] = useState(0);
    const [canvasLeft, setcanvasLeft] = useState(0);
    const [canvasTop, setcanvasTop] = useState(0);
    const [rect, setrect] = useState(0)
    // const [isMouseDown,setisMouseDown]=useState(false)
    const centerIndex = 5
    useEffect(() => {
        // 获取grid-container的宽度并更新state
        if (gridContainerRef.current && gridContainerRef1.current) {
            const width = gridContainerRef.current.offsetWidth;
            const height = gridContainerRef1.current.offsetHeight;
            setGridHeight(height);
            setGridWidth(width);
        }
    }, []);
    useEffect(() => {
        setTimeout(() => {
            const divElement = document.getElementById('viewportBackfillDisplay0'); // 通过元素的 ID 或其他方式获取
            const rect = divElement.getBoundingClientRect();
            setrect(rect)
            if (divElement) {
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
                setcanvasTop(rect.top + scrollTop)
                setcanvasLeft(rect.left + scrollLeft)
            }
            
            // 等待页面加载完成后获取一次canvas的宽度和高度
            const canvasWidth = $('#viewportBackfillDisplay0').width();
            const canvasHeight = $('#viewportBackfillDisplay0').height();
            setCanvasWidth(canvasWidth);
            setCanvasHeight(canvasHeight);
        }, 1000)
        let isMouseDown=false
        const getoff=()=>{
            if (isMouseDown){
                const divElement = document.getElementById('viewportBackfillDisplay0'); // 通过元素的 ID 或其他方式获取
                const rect = divElement.getBoundingClientRect();
                setrect(rect)
                if (divElement) {
                    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
                    setcanvasTop(rect.top + scrollTop)
                    setcanvasLeft(rect.left + scrollLeft)
            }
            }
            
        }
        window.addEventListener('mousedown',()=>{isMouseDown=true})
        window.addEventListener('mouseup',()=>{isMouseDown=false})
        window.addEventListener('mousemove',getoff)
        // 添加窗口大小变化事件监听器
        const handleResize = () => {
            const canvasWidth = $('#viewportBackfillDisplay0').width();
            const canvasHeight = $('#viewportBackfillDisplay0').height();
            setCanvasWidth(canvasWidth);
            setCanvasHeight(canvasHeight);
        };

        window.addEventListener('wheel', handleResize);

        // 在组件卸载时移除事件监听器
        return () => {
            window.removeEventListener('wheel', handleResize);
        };
    }, []);
    

    const gridItems = Array.from({ length: column }, (_, colIndex) => {
        const cellWidth = (gridWidth / column) * (colIndex - centerIndex);
        return (
            <div
                className="grid-column"
                key={`column-${colIndex}`}

            > {colIndex > 0 && (
                <span className="span">{`${(ZifData.Width * ZifData.voxelResolution * cellWidth / (canvasWidth-canvasLeft)/1000).toFixed(2)}mm`}</span>
            )}
                {colIndex == 0 && (<span className="span">unit/mm</span>)}
                {/* {isCenter && <span className="span">0</span>} */}
            </div>
        );
    });

    const gridRow = Array.from({ length: column }, (_, colIndex) => {
        const cellHeight = (gridHeight / column) * (colIndex);
        return (
            <div
                className="grid-row"
                key={`row-${colIndex}`}
            > {colIndex > 0 && (
                <span className="span">{`${(ZifData.Height * ZifData.voxelResolution * cellHeight / (canvasHeight-canvasTop)/1000).toFixed(2)}mm`}</span>
            )}
            </div>
        );
    });

    return (
        <div id='ex'>
            <div className="grid-container" ref={gridContainerRef}>
                {gridItems}
            </div>
            <div className="grid-container1" ref={gridContainerRef1}>
                {gridRow}
            </div>
        </div>
    );
};

export default GridViewer;
